// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SessionStorageProvider } from './contexts/SessionStorageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import { CampaignAccessProvider } from './contexts/CampaignAccessContext';

import Dashboard     from './components/Dashboard';
import ClientsPage from './components/ClientsPage';
import SettingsPage from './components/SettingsPage';
import HelpPage from './components/HelpPage';
import UsagePage from './components/UsagePage';
import AdminOperationsPage from './components/AdminOperationsPage';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './components/LandingPage';
import PricingPage from './components/PricingPage';
import AuthPage from './components/AuthPage';
import EmailAccessPage from './components/EmailAccessPage';
import NotFoundPage from './components/NotFoundPage';
import PrivateFlyerViewer from './components/PrivateFlyerViewer';

function PrivateFlyerRoute() {
  const { assetId } = useParams();
  return <PrivateFlyerViewer assetId={assetId} />;
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <CampaignAccessProvider>
          <SessionStorageProvider>
            <NotificationsProvider>
            <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<AuthPage />} />

          {/* Protected */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* The Microsoft connect page. It has existed all along but had no
              route, so the only way back to a working mailbox was to sign out
              and in again. Every "Connect mailbox" control points here. */}
          <Route
            path="/connect-email"
            element={
              <ProtectedRoute>
                <EmailAccessPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <ClientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <HelpPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/flyers/:assetId"
            element={
              <ProtectedRoute>
                <PrivateFlyerRoute />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usage"
            element={
              <ProtectedRoute requireUsageAdmin>
                <UsagePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operations"
            element={
              <ProtectedRoute requireUsageAdmin>
                <AdminOperationsPage />
              </ProtectedRoute>
            }
          />

          {/* Catch-all. Hosting rewrites every path to this shell, so without a
              "*" route an unknown path rendered an empty page on a public
              domain. It stays LAST: react-router takes the first match, and a
              "*" placed earlier would swallow every route below it. */}
          <Route path="*" element={<NotFoundPage />} />
            </Routes>
            </NotificationsProvider>
          </SessionStorageProvider>
          </CampaignAccessProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
